// V8: Center screen bold flash — brief, dramatic, then fades
import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill, spring } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";

const { fontFamily: inter } = loadInter("normal", { weights: ["700", "800", "900"], subsets: ["latin"] });

const TempleSVG: React.FC = () => (
  <svg width="29" height="32" viewBox="0 0 110 120" fill="none">
    <rect x="5" y="100" width="100" height="10" rx="2" fill="#C8A96E" />
    <rect x="18" y="72" width="74" height="30" rx="2" fill="#E8C97E" stroke="#8B6914" strokeWidth="1.5" />
    <path d="M42 102 L42 82 Q55 72 68 82 L68 102Z" fill="#5C3D1E" />
    <path d="M12 72 L98 72 L88 58 L22 58Z" fill="#D4A853" stroke="#8B6914" strokeWidth="1" />
    <path d="M22 58 L88 58 L80 44 L30 44Z" fill="#E8C97E" stroke="#8B6914" strokeWidth="1" />
    <path d="M32 44 L78 44 L55 10Z" fill="#D4A853" stroke="#8B6914" strokeWidth="1" />
    <circle cx="55" cy="8" r="5" fill="#FFD700" />
    <line x1="55" y1="72" x2="55" y2="82" stroke="#8B6914" strokeWidth="2" />
    <path d="M55 82 C55 82 46 84 45 94 L65 94 C64 84 55 82 55 82Z" fill="#FFD700" stroke="#B8860B" strokeWidth="1.5" />
  </svg>
);

export const DevaKathaLS8: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const scaleIn = spring({ frame, fps, config: { damping: 12, stiffness: 200 }, durationInFrames: Math.round(0.5 * fps) });
  const s = interpolate(scaleIn, [0, 1], [0.6, 1]);

  const opacity = interpolate(frame, [0, Math.round(0.3 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });
  const fadeOut = interpolate(frame, [Math.round(3.5 * fps), Math.round(4 * fps)], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const likeClicked = frame >= Math.round(1.6 * fps);
  const subClicked = frame >= Math.round(2.5 * fps);

  const likeScale = interpolate(frame, [Math.round(1.6 * fps), Math.round(1.67 * fps), Math.round(1.8 * fps)], [1, 0.84, 1.08], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });
  const subScale = interpolate(frame, [Math.round(2.5 * fps), Math.round(2.57 * fps), Math.round(2.7 * fps)], [1, 0.84, 1.08], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, opacity: opacity * fadeOut, transform: 'scale(1.5)', transformOrigin: 'bottom right' }}>
      <div style={{
        position: "absolute", bottom: 40, right: 40,
        transform: `scale(${s})`, transformOrigin: "bottom right",
        background: "rgba(5,3,1,0.92)", backdropFilter: "blur(12px)",
        borderRadius: 12, padding: "11px 16px",
        border: "1px solid rgba(255,215,0,0.4)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.7)",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 8,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
          <TempleSVG />
          <div>
            <div style={{ color: "#FFD700", fontSize: 13, fontWeight: 900, fontFamily: inter, letterSpacing: 1 }}>Deva Katha</div>
            <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 7, fontWeight: 500, fontFamily: inter }}>& Mandir Yatra</div>
          </div>
        </div>
        <div style={{ width: "100%", height: 1, background: "rgba(255,215,0,0.2)" }} />
        <div style={{ display: "flex", gap: 11 }}>
          <div style={{
            background: likeClicked ? "#1a73e8" : "rgba(255,255,255,0.1)",
            border: `2px solid ${likeClicked ? "#1a73e8" : "rgba(255,255,255,0.2)"}`,
            borderRadius: 15, padding: "5px 13px",
            transform: `scale(${likeScale})`,
            boxShadow: likeClicked ? "0 4px 20px rgba(26,115,232,0.6)" : "none",
          }}>
            <span style={{ color: "#fff", fontSize: 10, fontWeight: 800, fontFamily: inter, whiteSpace: "nowrap" }}>{likeClicked ? "👍 Liked!" : "👍 Like"}</span>
          </div>
          <div style={{
            background: subClicked ? "#606060" : "#FF0000",
            borderRadius: 15, padding: "5px 13px",
            transform: `scale(${subScale})`,
            boxShadow: subClicked ? "none" : "0 4px 24px rgba(255,0,0,0.6)",
          }}>
            <span style={{ color: "#fff", fontSize: 10, fontWeight: 800, fontFamily: inter, whiteSpace: "nowrap" }}>{subClicked ? "Subscribed ✓" : "Subscribe"}</span>
          </div>
        </div>
      </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
